export default __webpack_public_path__ + "dfe2eb7b60114a7d94de5c8c67f8fb23.png";